import {orgRepositoriesPath} from '@github-ui/paths'
import type React from 'react'

import {MatchingRepositoriesCount} from '../components/MatchingRepositoriesCount'
import {DynamicReposPicker} from '../DynamicReposPicker'
import {MultiSelectReposPicker} from '../MultiSelectReposPicker'
import type {Mode} from '../Selection'

const all = {
  name: 'all',
  label: 'All repositories',
  description: 'Include all current and future repositories',
}

interface BuildMultipleProps extends React.ComponentProps<typeof MultiSelectReposPicker> {
  name?: string
}

function buildMultiple({name, ...pickerProps}: BuildMultipleProps): Mode {
  return {
    name: name || 'multiple',
    label: 'Only selected repositories',
    description: 'Applies only to specifically selected repositories',
    renderEditor: ({shouldOpen, labelId, descriptionId}) => (
      <MultiSelectReposPicker
        {...pickerProps}
        isOpenInitially={shouldOpen}
        aria-describedby={`${labelId} ${descriptionId}`}
      />
    ),
    editorDescription: '',
  }
}

interface BuildFilterProps extends React.ComponentProps<typeof DynamicReposPicker> {
  name?: string
}

function buildFilter({name, ...pickerProps}: BuildFilterProps): Mode {
  return {
    name: name || 'filter',
    label: 'Repositories matching a filter',
    description: 'Applies to repositories that match now and in the future',
    renderEditor: ({shouldOpen, labelId, descriptionId}) => (
      <DynamicReposPicker
        {...pickerProps}
        isOpenInitially={shouldOpen}
        aria-describedby={`${labelId} ${descriptionId}`}
      />
    ),
    editorDescription: (
      <MatchingRepositoriesCount
        scope={pickerProps.scope}
        query={pickerProps.query}
        href={
          pickerProps.scope.type === 'organization'
            ? orgRepositoriesPath({owner: pickerProps.scope.slug, query: pickerProps.query || ''})
            : undefined
        }
      />
    ),
  }
}

export const modes = {all, buildMultiple, buildFilter}
